function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6561 10C29.7372 7.89441 28.1212 6.16944 26.08 5.11515C24.0388 4.06087 21.6968 3.74157 19.4479 4.21095C17.1989 4.68033 15.1802 5.90976 13.7311 7.69252C12.282 9.47527 11.491 11.7026 11.491 14C11.491 16.2974 12.282 18.5248 13.7311 20.3075C15.1802 22.0903 17.1989 23.3197 19.4479 23.7891C21.6968 24.2585 24.0388 23.9392 26.08 22.8849C28.1212 21.8306 29.7372 20.1056 30.6561 18H38.5001L42.5001 21L46.5001 18H51.5001L53.5001 10H30.6561Z",
  stroke: "#9AA0B3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 34H13.5C18.1 34 23.1 36.4 25.5 40H33.5C37.5 40 41.5 44 41.5 48H23.5",
  stroke: "#9AA0B3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.3 44H53.5C60.7 44 61.5 48 61.5 48L32.9 59.6C31.7852 60.0626 30.5851 60.2839 29.3786 60.2494C28.1721 60.215 26.9866 59.9255 25.9 59.4L11.5 52",
  stroke: "#9AA0B3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 30H3.5V56H11.5V30Z",
  stroke: "#9AA0B3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 17C21.1569 17 22.5 15.6569 22.5 14C22.5 12.3431 21.1569 11 19.5 11C17.8431 11 16.5 12.3431 16.5 14C16.5 15.6569 17.8431 17 19.5 17Z",
  stroke: "#9AA0B3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.10f94a19.svg";
export { ForwardRef as ReactComponent };